import { render, staticRenderFns } from "./AddCustomLandingPageUrlModal.vue?vue&type=template&id=66c03a02"
import script from "./AddCustomLandingPageUrlModal.vue?vue&type=script&lang=js"
export * from "./AddCustomLandingPageUrlModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports